var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutGoingCall33(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25835 0.741653C9.25835 0.465511 9.03449 0.241653 8.75835 0.241653L4.25835 0.241653C3.9822 0.241653 3.75835 0.465511 3.75835 0.741653C3.75835 1.0178 3.9822 1.24165 4.25835 1.24165H8.25835V5.24165C8.25835 5.5178 8.4822 5.74165 8.75835 5.74165C9.03449 5.74165 9.25835 5.5178 9.25835 5.24165L9.25835 0.741653ZM1.59525 8.61185L9.1119 1.09521L8.40479 0.3881L0.888146 7.90475L1.59525 8.61185Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutGoingCall33);
export default __webpack_public_path__ + "static/media/outGoingCall 33.89bfa60f740b573b9c77a038232a472f.svg";
export { ForwardRef as ReactComponent };